import React, { useState } from 'react';
import { MapPinIcon, CameraIcon, SendIcon, CheckIcon } from 'lucide-react';
import Header from '../components/Header';
const Maintenance = () => {
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [hasPhoto, setHasPhoto] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    // In een echte app zou dit naar een API gaan
    setIsSubmitted(true);
  };
  if (isSubmitted) {
    return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-467">
        <Header title="Onderhoudsmelding" showBackButton data-id="element-468" />
        <div className="p-4 flex-1 flex flex-col items-center justify-center" data-id="element-469">
          <div className="bg-white rounded-lg shadow-sm p-6 w-full max-w-md text-center" data-id="element-470">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-471">
              <CheckIcon size={32} className="text-green-600" data-id="element-472" />
            </div>
            <h2 className="text-xl font-bold mb-2" data-id="element-473">Bedankt voor je melding!</h2>
            <p className="text-gray-600 mb-4" data-id="element-474">
              We gaan zo snel mogelijk aan de slag om het probleem op te lossen.
            </p>
            <button onClick={() => setIsSubmitted(false)} className="bg-[#f9b30f] text-black py-2 px-4 rounded-lg font-medium" data-id="element-475">
              Nieuwe melding maken
            </button>
          </div>
        </div>
      </div>;
  }
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-476">
      <Header title="Onderhoudsmelding" showBackButton data-id="element-477" />
      <div className="p-4" data-id="element-478">
        <div className="bg-white rounded-lg shadow-sm p-4 mb-4" data-id="element-479">
          <h2 className="text-lg font-bold mb-2" data-id="element-480">Probleem melden</h2>
          <p className="text-sm text-gray-600 mb-4" data-id="element-481">
            Heb je een probleem ontdekt op de camping? Laat het ons weten, dan
            lossen we het zo snel mogelijk op!
          </p>
          <form onSubmit={handleSubmit} data-id="element-482">
            <div className="mb-4" data-id="element-483">
              <label className="block text-sm font-medium mb-1" data-id="element-484">
                Beschrijving van het probleem
              </label>
              <textarea value={description} onChange={e => setDescription(e.target.value)} className="w-full border border-gray-300 rounded-lg p-2 text-sm" rows={4} placeholder="Bijv. Douche bij gebouw 2 is verstopt" required data-id="element-485" />
            </div>
            <div className="mb-4" data-id="element-486">
              <label className="block text-sm font-medium mb-1" data-id="element-487">Locatie</label>
              <div className="relative" data-id="element-488">
                <input type="text" value={location} onChange={e => setLocation(e.target.value)} className="w-full border border-gray-300 rounded-lg p-2 pl-8 text-sm" placeholder="Bijv. Standplaats 42 of Sanitairgebouw" required data-id="element-489" />
                <MapPinIcon size={16} className="absolute left-2 top-2.5 text-gray-400" data-id="element-490" />
              </div>
            </div>
            <div className="mb-6" data-id="element-491">
              <button type="button" onClick={() => setHasPhoto(!hasPhoto)} className={`w-full border border-gray-300 rounded-lg p-3 flex items-center justify-center text-sm ${hasPhoto ? 'bg-gray-50' : ''}`} data-id="element-492">
                <CameraIcon size={18} className="mr-2" data-id="element-493" />
                {hasPhoto ? 'Foto toegevoegd' : 'Foto toevoegen (optioneel)'}
              </button>
            </div>
            <button type="submit" className="w-full bg-[#f9b30f] text-black py-3 rounded-lg flex items-center justify-center font-medium" data-id="element-494">
              <SendIcon size={18} className="mr-2" data-id="element-495" />
              Melding versturen
            </button>
          </form>
        </div>
      </div>
    </div>;
};
export default Maintenance;